import {
  addDays, differenceInDays, isValid, parse,
} from 'date-fns';
import { isNil } from 'lodash';

const origin = parse('2022-01-01', 'yyyy-MM-dd', new Date());

const getDayIdFromDate = (date) => {
  if (!date || !isValid(date)) return null;

  return differenceInDays(date, origin) + 1;
};

const getDateFromDayId = (dayId) => {
  if (isNil(dayId)) return null;

  return addDays(origin, +dayId - 1);
};

const dayId = {
  getDayIdFromDate,
  getDateFromDayId,
};

export default dayId;
